import { ChaveContratoEnum } from '../ChaveContratoEnum';
import { ContratoMenuModel } from './ContratoMenuModel';
import { RecomendacaoMenuModel } from './RecomendacaoMenuModel';
import { HomeMenuEstiloModel } from './HomeMenuEstiloModel';
import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';
import { DrawerMenuModel } from './DrawerMenuModel';

export class HomeMenuModel extends ContratoMenuModel {

    title: String
    description: String
    icon: String
    page: String
    estilo: HomeMenuEstiloModel
    chaveContrato: Array<String>
    active: boolean
    novo: Boolean = false
    divStyle: String
    iconStyle: String

    public static salvaPreferenciasUser(nameMenuArray: String[], userId: Number): Promise<PhicubeResponse> {
        return new GatewayService().requestPut('/api/user/preferencias/' + userId, nameMenuArray)
    }

    public static getPreferenciasUser(userId: Number): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/user/preferencias/' + userId)
    }

    public static apagaPreferenciasUser(userId: Number): Promise<PhicubeResponse> {
        return new GatewayService().requestDel('/api/user/preferencias/' + userId)
    }

    public static getBannerHome(): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/carrosseis/banner')
    }

    public static getNoticias(limit: number, offset: number): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/noticias/' + limit + '/' + offset)
    }

    public static getListaAtivosDestaque(): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/ativos/destaques/' + 6)
    }

    public static async getMenuHome(): Promise<Array<HomeMenuModel>> {
        const menu: Array<HomeMenuModel> = []
        let item

        const user = await new DrawerMenuModel().obtemUsuarioLogado()

        item = new HomeMenuModel()
        item.title = "Ações Brasil recomendadas"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES
        ]
        item.icon = "../../assets/img/home/icon-bolsa.svg"
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_ACOES_BOLSA
        item.active = true
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Criptoativos recomendados"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_CRIPTOMOEDAS
        ]
        item.icon = "../../assets/img/home/icon-digital2.svg"
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_CRIPTOMOEDAS
        item.active = true
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Ações EUA recomendadas"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_EUA
        ]
        item.icon = "../../assets/img/home/icon-bolsa-usa.svg"
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_EUA
        item.active = true
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Prisma PhiCube"
        item.icon = "../../assets/img/home/icon-prisma.svg"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_PRISMA_ACOES,
            ChaveContratoEnum.CONTRATO_PRISMA_CRIPTOMOEDAS,
            ChaveContratoEnum.CONTRATO_PRISMA_EUA,
            ChaveContratoEnum.CONTRATO_PRISMA_FUNDOS_IMOBILIARIOS,
            ChaveContratoEnum.CONTRATO_PRISMA_FUNDOS_INDICES,
            ChaveContratoEnum.CONTRATO_PRISMA_INDICES
        ]
        item.active = true
        item.page = 'navigation/prisma'
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Análise de ativos"
        item.icon = "../../assets/img/bottom-bar-icon-solicita-selected.svg"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_ANALISE_ACOES,
            ChaveContratoEnum.CONTRATO_ANALISE_CRIPTOMOEDAS,
            ChaveContratoEnum.CONTRATO_ANALISE_EUA,
            ChaveContratoEnum.CONTRATO_ANALISE_FUNDOS_IMOBILIARIOS,
            ChaveContratoEnum.CONTRATO_ANALISE_FUNDOS_INDICES,
            ChaveContratoEnum.CONTRATO_ANALISE_INDICES
        ]
        item.active = true
        item.page = 'navigation/analise-ativos'
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Carteiras recomendadas"
        item.icon = "../../assets/img/home/icon-carteira-recomendada.svg"
        item.active = true
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        item.page = 'navigation/carteira-recomendada'
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Opções"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_OPCOES_BRASIL
        ]
        item.icon = "../../assets/img/home/icon-opcoes.svg"
        item.page = 'navigation/recomendacoes-opcoes/' + RecomendacaoMenuModel.TIPO_ACOES_BOLSA
        item.active = true
        item.estilo = new HomeMenuEstiloModel()
        item.divStyle = 'padding: 0.6rem!important;'
        item.iconStyle = 'width: 3.5rem!important; height: 3.5rem!important;'
        item.novo = true
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "BDRs recomendados"
        item.icon = "../../assets/img/bdr.svg"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_BDR
        ]
        item.active = true
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_BDR
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Indicar app"
        item.icon = "../../assets/img/home/icon-compartilha.svg"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_INDICAR_APP
        ]
        item.active = true
        item.page = ''
        item.estilo = new HomeMenuEstiloModel()
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        menu.push(item)


        item = new HomeMenuModel()
        item.title = "FIIs recomendados"
        item.icon = "../../assets/img/home/icon-fiis.svg"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_IMOBILIARIOS
        ]
        item.active = true
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_FUNDOS_IMOBILIARIOS
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "ETFs recomendados"
        item.icon = "../../assets/img/home/icon-indice-setorial.svg"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_INDICES
        ]
        item.active = true
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_FUNDOS_INDICE
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Afiliados"
        item.icon = "../../assets/img/afiliados.svg"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_RECOMENDACAO_BDR
        ]
        item.active = false
        item.page = 'navigation/'
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Configurações"
        item.icon = "../../assets/img/home/icon-config.svg"
        item.chaveContrato = []
        item.active = true
        item.page = 'navigation/configuracoes'
        item.estilo = new HomeMenuEstiloModel()
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        menu.push(item)


        item = new HomeMenuModel()
        item.title = "Avaliar app"
        item.icon = "../../assets/img/home/icon-like.svg"
        item.chaveContrato = []
        item.active = true
        item.page = 'avaliacao'
        item.estilo = new HomeMenuEstiloModel()
        item.nivelRestricao = ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Prospecção de Cliente"
        item.chaveContrato = []
        item.icon = '../../assets/img/home/icon-user.svg'
        item.page = 'client-prospect'
        item.active = user.aai ? true : false
        item.estilo = new HomeMenuEstiloModel()
        item.nivelRestricao = user.aai ? ContratoMenuModel.NIVEL_RESTRICAO_BAIXO : ContratoMenuModel.NIVEL_RESTRICAO_ALTO
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Commodities recomendados"
        item.chaveContrato = []
        item.icon = "../../assets/img/home/icon-commodities.svg"
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_FUTUROS_BOLSA
        item.active = false
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Futuros recomendados"
        item.chaveContrato = []
        item.icon = "../../assets/img/home/icon-futuros.svg"
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_FUTUROS_BOLSA
        item.active = false
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "FOREX recomendados"
        item.chaveContrato = []
        item.icon = "../../assets/img/home/icon-forex.svg"
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_FUTUROS_BOLSA
        item.active = false
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Educacional"
        item.chaveContrato = []
        item.icon = "../../assets/img/home/icon-education.svg"
        item.page = ''
        item.active = false
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        item = new HomeMenuModel()
        item.title = "Pesquisa do Investidor"
        item.icon = "../../assets/img/home/icon-formulario.svg"
        item.chaveContrato = [
            ChaveContratoEnum.CONTRATO_FORMULARIO_TRADER
        ]
        item.active = false
        item.page = 'formulario-trader'
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)

        /*item = new HomeMenuModel()
        item.title = "Análise Fundamentalista"
        item.chaveContrato = []
        item.icon = "../../assets/img/home/icon-indice-setorial.svg"
        item.page = 'navigation/recomendacoes/' + RecomendacaoMenuModel.TIPO_FUTUROS_BOLSA
        item.active = false
        item.estilo = new HomeMenuEstiloModel()
        menu.push(item)*/

        return menu;
    }
}